/**
 * TanStack Query hooks for `role-types-default-advertiser-manager-affiliate-ma`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	roleTypesDefaultAdvertiserManagerAffiliateMaQueryKeys,
	type CreateRoleTypesDefaultAdvertiserManagerAffiliateMaBody,
	type ListRoleTypesDefaultAdvertiserManagerAffiliateMaResponse,
	type RoleTypesDefaultAdvertiserManagerAffiliateMaRow,
} from "./api";

export function useRoleTypesDefaultAdvertiserManagerAffiliateMaList(): UseQueryResult<ListRoleTypesDefaultAdvertiserManagerAffiliateMaResponse, Error> {
	return useQuery({
		queryKey: roleTypesDefaultAdvertiserManagerAffiliateMaQueryKeys.list(),
		queryFn: list,
	});
}

export function useRoleTypesDefaultAdvertiserManagerAffiliateMaCreate(): UseMutationResult<RoleTypesDefaultAdvertiserManagerAffiliateMaRow, Error, CreateRoleTypesDefaultAdvertiserManagerAffiliateMaBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: roleTypesDefaultAdvertiserManagerAffiliateMaQueryKeys.all });
		},
	});
}

export function useRoleTypesDefaultAdvertiserManagerAffiliateMaDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: roleTypesDefaultAdvertiserManagerAffiliateMaQueryKeys.all });
		},
	});
}
